import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';
import { supabase } from './supabaseClient';
import Auth from './components/Auth';
import Dashboard from './components/Dashboard';
import PublicForm from './components/PublicForm';
import ResetPassword from './components/ResetPassword';
import UpdatePassword from './components/UpdatePassword';

function AuthConfirm() {
  const navigate = useNavigate();
  const [status, setStatus] = useState('confirming');

  useEffect(() => {
    const confirmEmail = async () => {
      try {
        const params = new URLSearchParams(window.location.search);
        const tokenHash = params.get('token_hash');
        const type = params.get('type');

        if (!tokenHash || !type) {
          setStatus('error');
          return;
        }

        const { data, error } = await supabase.auth.verifyOtp({
          token_hash: tokenHash,
          type: type
        });

        if (error) {
          console.error('Confirmation error:', error);
          setStatus('error');
          return;
        }

        if (data.session) {
          setStatus('confirmed');
          setTimeout(() => {
            navigate('/dashboard');
          }, 1500);
        } else {
          setStatus('confirmed');
          setTimeout(() => {
            navigate('/login');
          }, 2000);
        }
      } catch (error) {
        console.error('Confirmation error:', error);
        setStatus('error');
      }
    };

    confirmEmail();
  }, [navigate]);

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'Poppins, sans-serif' }}>
      <div style={{ textAlign: 'center', maxWidth: '500px', padding: '40px', background: 'white', borderRadius: '16px', boxShadow: '0 4px 20px rgba(0,0,0,0.1)' }}>
        {status === 'confirming' && (
          <>
            <div style={{ fontSize: '48px', marginBottom: '20px' }}>⏳</div>
            <h2 style={{ fontSize: '24px', fontWeight: '600', color: '#1e293b', marginBottom: '10px' }}>
              Confirming your email...
            </h2>
            <p style={{ color: '#64748b', fontSize: '16px' }}>Please wait a moment</p>
          </>
        )}
        
        {status === 'confirmed' && (
          <>
            <div style={{ fontSize: '64px', marginBottom: '20px' }}>✅</div>
            <h2 style={{ fontSize: '24px', fontWeight: '600', color: '#1e293b', marginBottom: '10px' }}>
              Email Confirmed!
            </h2>
            <p style={{ color: '#64748b', fontSize: '16px' }}>Redirecting you...</p>
          </>
        )}

        {status === 'error' && (
          <>
            <div style={{ fontSize: '64px', marginBottom: '20px' }}>❌</div>
            <h2 style={{ fontSize: '24px', fontWeight: '600', color: '#1e293b', marginBottom: '10px' }}>
              Confirmation Failed
            </h2>
            <p style={{ color: '#64748b', fontSize: '16px', marginBottom: '20px' }}>
              This link may have expired or is invalid.
            </p>
            <button
              onClick={() => navigate('/login')}
              style={{ padding: '12px 24px', background: '#3b82f6', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '16px', fontWeight: '500' }}
            >
              Go to Sign In
            </button>
          </>
        )}
      </div>
    </div>
  );
}

export default function App() {
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
      setLoading(false);
    });

    const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
      setSession(session);
      if (event === 'SIGNED_IN') {
        setLoading(false);
      }
    });

    return () => subscription.unsubscribe();
  }, []);

  if (loading) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div style={{ fontSize: '18px', color: '#3b82f6', fontWeight: '500', fontFamily: 'Poppins, sans-serif' }}>Loading...</div>
      </div>
    );
  }

  return (
    <Router>
      <Routes>
        <Route path="/auth/confirm" element={<AuthConfirm />} />
        <Route path="/" element={session ? <Dashboard user={session.user} /> : <Auth />} />
        <Route path="/login" element={<Auth />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/update-password" element={<UpdatePassword />} />
        <Route path="/dashboard" element={session ? <Dashboard user={session.user} /> : <Auth />} />
        <Route path="/:slug" element={<PublicForm />} />
      </Routes>
    </Router>
  );
}
